const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3006/api';

// Generic API request function
export async function apiRequest(endpoint, options = {}) {
  const url = `${API_BASE_URL}${endpoint}`;

  const config = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    },
    ...options
  };

  // Remove Content-Type for FormData requests
  if (options.body instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  try {
    const response = await fetch(url, config);

    // Check status first before parsing JSON
    if (!response.ok) {
      let errorMessage = `HTTP error! status: ${response.status}`;

      // Try to parse error response as JSON if possible
      try {
        const contentType = response.headers.get('content-type');
        if (contentType && contentType.includes('application/json')) {
          const errorData = await response.json();
          errorMessage = errorData.error || errorMessage;
        }
      } catch (parseError) {
        // If JSON parsing fails, use default error message
        console.warn('Could not parse error response as JSON:', parseError);
      }

      throw new Error(errorMessage);
    }

    // Parse successful response as JSON
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('API request failed:', error);
    throw error;
  }
}

// GET request
export function get(endpoint) {
  return apiRequest(endpoint, { method: 'GET' });
}

// POST request
export function post(endpoint, body) {
  return apiRequest(endpoint, {
    method: 'POST',
    body: body instanceof FormData ? body : JSON.stringify(body)
  });
}

// PUT request
export function put(endpoint, body) {
  return apiRequest(endpoint, {
    method: 'PUT',
    body: body instanceof FormData ? body : JSON.stringify(body)
  });
}

// DELETE request
export function del(endpoint) {
  return apiRequest(endpoint, { method: 'DELETE' });
}
